import { configureStore } from '@reduxjs/toolkit'
import pageReducer from '../store/reducers/pageManageReducer'
import docsReducer from '../store/reducers/documentsReducers'
import verifyReducer from '../store/reducers/userVerifyReducers'
import paymentsReducer from '../store/reducers/paymentsReducers'
import advertisementsReducer from '../store/reducers/adversitementsReducers'

const store = configureStore({
	reducer: {
		pageManage: pageReducer,
		documentsList: docsReducer,
		verify: verifyReducer,
        payments: paymentsReducer,
        advertisements: advertisementsReducer,
	},
})

export default store
